var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "absolute transition-all duration-300",
      style: {
        top: _vm.period.position.top,
        left: _vm.period.position.left
      }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "border border-l-4 rounded-lg bg-pure-white p-1 flex flex-col justify-between gap-1 shadow-md transition-all duration-300",
          style: {
            height: _vm.period.element.height,
            width: _vm.period.element.width,
            borderColor: _vm.period.element.borderColor
          },
          attrs: { id: "my-session-slot" }
        },
        [
          _c(
            "div",
            {
              staticClass: "relative h-full w-full rounded py-1 px-1.5",
              style: { backgroundColor: _vm.period.secondary_color },
              on: {
                click: function($event) {
                  _vm.detailsOpened = true
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "cursor-pointer h-full flex flex-col justify-center gap-1",
                  attrs: { title: _vm.period.client.name }
                },
                [
                  _c("BlTextSubtitle3", {
                    staticClass: "truncate",
                    style: { color: _vm.period.primary_color },
                    attrs: { text: "" + _vm.period.client.name }
                  }),
                  _vm._v(" "),
                  _vm.isHasThreeSpaces
                    ? _c("BlTextBody2", {
                        style: { color: _vm.period.primary_color },
                        attrs: {
                          text:
                            _vm.period.start_time_string +
                            " - " +
                            _vm.period.end_time_string
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.period.room && _vm.isHasTwoSpaces
                    ? _c("BlTextSubtitle3", {
                        staticClass: "truncate",
                        style: { color: _vm.period.primary_color },
                        attrs: { text: "" + _vm.period.room.name }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.enableBranch &&
                  _vm.period.room.branch &&
                  _vm.isHasTwoSpaces
                    ? _c("BlTextBody2", {
                        staticClass: "truncate",
                        style: { color: _vm.period.primary_color },
                        attrs: { text: _vm.period.room.branch.name }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.detailsOpened
                ? _c(
                    "div",
                    {
                      staticClass:
                        "absolute top-0 flex flex-col gap-1 mx-2 w-64 flex-shrink-0 bg-pure-white rounded border border-grey-200 overflow-y-auto shadow-md",
                      class: [
                        _vm.period.is_last_column ? "right-full" : "left-full"
                      ],
                      style: { zIndex: 2 },
                      attrs: { "data-id": _vm.dataId }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-full h-8 flex-shrink-0 flex items-center justify-between px-3",
                          class: {
                            "bg-orange-200": _vm.period.status === "scheduled",
                            "bg-cornflower-200":
                              _vm.period.status === "in_progress",
                            "bg-lime-200": _vm.period.status === "completed",
                            "bg-error-100": _vm.period.status === "cancelled"
                          },
                          attrs: { "data-id": _vm.dataId }
                        },
                        [
                          _c("BlTextBody3", {
                            staticClass: "capitalize",
                            class: {
                              "text-orange": _vm.period.status === "scheduled",
                              "text-cornflower-800":
                                _vm.period.status === "in_progress",
                              "text-lime": _vm.period.status === "completed",
                              "text-error": _vm.period.status === "cancelled"
                            },
                            attrs: {
                              "data-id": _vm.dataId,
                              text: _vm.period.status.replaceAll("_", " ")
                            }
                          }),
                          _vm._v(" "),
                          _c("BlIcon", {
                            staticClass: "h-4 w-4",
                            attrs: {
                              icon: "close",
                              color:
                                _vm.period.status === "scheduled"
                                  ? "orange"
                                  : _vm.period.status === "in_progress"
                                  ? "cornflower-8"
                                  : _vm.period.status === "completed"
                                  ? "success"
                                  : "error",
                              clickable: ""
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "p-3 flex-shrink-0 flex flex-col gap-3",
                          attrs: { "data-id": _vm.dataId }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flex flex-col gap-1",
                              attrs: { "data-id": _vm.dataId }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "flex",
                                  attrs: { title: _vm.period.client.name }
                                },
                                [
                                  _c("BlTextSubtitle3", {
                                    staticClass: "truncate",
                                    attrs: {
                                      "data-id": _vm.dataId,
                                      text: _vm.period.client.name
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: {
                                  "data-id": _vm.dataId,
                                  text: _vm.displayDate(_vm.period.date)
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: {
                                  "data-id": _vm.dataId,
                                  text:
                                    _vm.period.start_time_string +
                                    " - " +
                                    _vm.period.end_time_string
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "flex flex-col items-start gap-1",
                              attrs: { "data-id": _vm.dataId }
                            },
                            [
                              _vm.enableBranch && _vm.period.room.branch
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "h-7 max-w-54 px-2 flex items-center justify-center rounded",
                                      style: {
                                        backgroundColor:
                                          _vm.period.room.branch
                                            .background_color || "unset"
                                      },
                                      attrs: { "data-id": _vm.dataId }
                                    },
                                    [
                                      _c("BlTextBody2", {
                                        staticClass: "truncate",
                                        style: {
                                          color:
                                            _vm.period.room.branch.color ||
                                            "unset"
                                        },
                                        attrs: {
                                          "data-id": _vm.dataId,
                                          text:
                                            _vm.period.room.branch.name || "-"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.period.room
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "max-w-54 flex",
                                      attrs: {
                                        "data-id": _vm.dataId,
                                        title: _vm.period.room.name
                                      }
                                    },
                                    [
                                      _c("BlTextBody2", {
                                        staticClass: "truncate",
                                        attrs: {
                                          "data-id": _vm.dataId,
                                          text: _vm.period.room.name
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "max-w-54 flex",
                                  attrs: { "data-id": _vm.dataId }
                                },
                                [
                                  !_vm.period.user
                                    ? _c("BlTextBody2", {
                                        staticClass: "italic truncate",
                                        attrs: {
                                          "data-id": _vm.dataId,
                                          title: "Deleted user",
                                          text: "Deleted user"
                                        }
                                      })
                                    : _c("BlTextBody2", {
                                        staticClass: "truncate",
                                        attrs: {
                                          "data-id": _vm.dataId,
                                          title: _vm.period.user.name,
                                          text: _vm.period.user.name
                                        }
                                      })
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "h-12 w-full flex-shrink-0 border-t border-slate-400 flex items-center justify-center gap-14 px-3"
                        },
                        [
                          _vm.period.status === "scheduled"
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "cursor-pointer",
                                  attrs: {
                                    title: "View session draft",
                                    to:
                                      "/session/" +
                                      _vm.period.session.slug +
                                      "/edit"
                                  }
                                },
                                [
                                  _c("BlTextSubtitle3", {
                                    staticClass: "text-light-purple",
                                    attrs: {
                                      "data-id": _vm.dataId,
                                      text: "View session draft"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.period.status === "in_progress"
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "cursor-pointer",
                                  attrs: {
                                    title: "Resume session",
                                    to: "/session/" + _vm.period.session.slug
                                  }
                                },
                                [
                                  _c("BlTextSubtitle3", {
                                    staticClass: "text-light-purple",
                                    attrs: {
                                      "data-id": _vm.dataId,
                                      text: "Resume session"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.period.status === "completed" ||
                          _vm.period.status === "cancelled"
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "cursor-pointer",
                                  attrs: {
                                    title: "View session",
                                    to: "/session/" + _vm.period.session.slug
                                  }
                                },
                                [
                                  _c("BlTextSubtitle3", {
                                    staticClass: "text-light-purple",
                                    attrs: {
                                      "data-id": _vm.dataId,
                                      text: "View session"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37cb244c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37cb244c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mySessions/timeslot/Slot.vue
// module id = null
// module chunks = 